export default __webpack_public_path__ + "static/media/WaterDistributionChange.d23cd285.png";